// Note: testimonials are static marketing content — no /api/testimonials
// endpoint exists on the BE. We deliberately bypass the
// REACT_APP_USE_MOCK_DATA flag here (which gates auctions / orders for
// real-vs-figma toggling) and always return the curated Czech copy below.
// When testimonials become editable from an admin / CMS, re-introduce the
// apiClient call + a corresponding BE endpoint.

export interface Testimonial {
  id: number;
  text: string;
  authorName?: string;
  avatarUrl?: string;
  moreLink?: string;
}

// Mock data for development - Czech testimonials
const mockTestimonials: Testimonial[] = [
  {
    id: 1,
    text: "Sledoval jsem aukci na iPhone a v posledních vteřinách jsem ho trefil za 127 Kč! Manželka mi nevěřila, dokud nepřišel balíček. Teď už kontroluje aukce se mnou každý večer 😄",
    authorName: "Petr N.",
    moreLink: "#",
  },
  {
    id: 2,
    text: "První aukci jsem prohrála, ale nevzdala jsem to. Třetí pokus a vyhrála jsem parfém za 89 Kč. Ten pocit, když vidíte 'Vyhráli jste!' je k nezaplacení!",
    authorName: "Lucie M.",
    moreLink: "#",
  },
  {
    id: 3,
    text: "Kamarád mi to doporučil a já nevěřil. Teď jsem vyhrál už třikrát - sluchátka, hodinky a tablet. Celkem za méně než 500 Kč. Prostě návyk 😅",
    authorName: "Tomáš H.",
    moreLink: "#",
  },
  {
    id: 4,
    text: "Dcera chtěla na Vánoce konkrétní hračku. Trefila jsem ji v aukci za 43 Kč místo 1200 Kč v obchodě. Nejlepší dárek pod stromečkem!",
    authorName: "Markéta S.",
    moreLink: "#",
  },
];

/**
 * Fetch testimonials. Always returns the curated static list (see file
 * header) — there is no BE endpoint for these yet. Promise wrapper kept so
 * call sites stay async and the eventual switch to a real fetch is a
 * single-file change.
 */
export const fetchTestimonials = async (): Promise<Testimonial[]> => {
  return mockTestimonials;
};
